module.exports = __webpack_public_path__ + "static/media/1_A1_09.53449bef.png";